import React, {useEffect} from "react";
import {ConfigProvider, DatePicker, Tooltip} from "antd";
import moment from "moment";
import "moment/locale/fi";

import CoursesHeader from "./CoursesHeader";
import {CourseRow} from "./CourseRow";
import {useCoursesList} from "./useCoursesList";

import dayjs from 'dayjs'
import {BookingHistoryDesktop} from "./BookingHistoryDesktop";

export default () => {
    const {setDateValue, days, filteredGolfCourses} = useCoursesList();
    return (
        <div className={'wrapper'} style={{
            overflow: "hidden",
        }}>
            <CoursesHeader days={days} picker={
                <Tooltip title='Valitse päivä'>
                    <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "left",
                    }}>
                        <ConfigProvider>
                            <DatePicker
                                //default value is today
                                defaultValue={dayjs()}
                                onChange={(date, dateString) => setDateValue(dateString)}
                                allowClear={false}
                                disabledDate={current => current.isBefore(moment().subtract(1, "day"))} //   picker='week'
                            />
                        </ConfigProvider>
                    </div>

                </Tooltip>
            }/>
            {
                filteredGolfCourses?.map((item, index) => <CourseRow key={item.id} index={index}/>)
            }
        </div>
    );
};
